import { useCallback, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useLocation, useNavigate } from 'react-router-dom';

import { Loader } from 'common/components/Loader/Loader';
import AlertComponent from 'common/components/ToastMessage/ToastMessage';
import {
	DOWNLOAD_SUCCESS_MESSAGE,
	DOWNLOAD_FAILED_ERROR_LABEL,
	DOWNLOAD_PROGRESS,
} from 'common/constants';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';
import { rrcpDashboardRoutes } from 'common/constants/rrcp-dashboard-routes';
import { RootState } from 'common/store/AppStore';
import { setToastMessage } from 'common/store/reducer/commonReducer';
import {
	downloadBlobFileWithMultiFormat,
	urlWithTenant,
} from 'common/utils/utilFunctions';

import { downloadFile } from '../api';

const { OK } = HTTP_STATUS_CODES;
const { parent } = rrcpDashboardRoutes;
const DownloadFile = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const [loading, setLoading] = useState<boolean>(false);

	const { isToastOpen, message, severity } = useSelector(
		(state: RootState) => state.common.toastMessage,
	);

	useEffect(() => {
		const { pathname } = location;
		const pathSegments = pathname.split('/').filter(Boolean);
		downLoadBulkSimulationFile(pathSegments[3], pathSegments[4]);
	}, [location]);

	const downLoadBulkSimulationFile = async (fileName: string, type: string) => {
		setLoading(true);
		const response = await downloadFile(fileName, type);
		if (response?.statusCode === OK) {
			const responseData: any = response?.responseBody;
			downloadBlobFileWithMultiFormat(responseData, fileName);
			dispatch(
				setToastMessage({
					message: DOWNLOAD_SUCCESS_MESSAGE,
					severity: 'success',
					isToastOpen: true,
				}),
			);
		} else {
			dispatch(
				setToastMessage({
					message: DOWNLOAD_FAILED_ERROR_LABEL,
					severity: 'error',
					isToastOpen: true,
				}),
			);
		}
		setLoading(false);
		navigate(urlWithTenant(parent));
	};

	const handleToast = useCallback(() => {
		dispatch(
			setToastMessage({
				isToastOpen: false,
				message: '',
				severity: '',
			}),
		);
	}, []);

	return (
		<div>
			<Loader show={loading} loaderText={DOWNLOAD_PROGRESS} />
			<AlertComponent
				open={isToastOpen ?? false}
				toastMessage={message ?? ''}
				severity={severity ?? ''}
				handleCloseMessage={handleToast}
				vertical="top"
				horizontal="right"
			/>
		</div>
	);
};

export default DownloadFile;
